import React from "react";
import Typical from "react-typical";
import ScrollService from "../../../utilities/ScrollService";
import "./Profile.css";

export default function Profile() {
  return (
    <div className="profile-container">
      <div className="profile-parent">
        <div className="profile-details">
          <div className="colz">
            <div className="colz-icon">
              <a href="https://github.com/swapnilpreet">
                <i className="fa fa-github-square"></i>
              </a>
              <a href="https://www.linkedin.com/in/swapnil-ramteke-12766a230/">
                <i className="fa fa-linkedin-square"></i>
              </a>
              <a href="https://www.instagram.com/swapnilpreet/">
                <i className="fa fa-instagram"></i>
              </a>
              <a href="https://twitter.com/mr_D_17">
                <i className="fa fa-twitter"></i>
              </a>
            </div>
          </div>

          <div className="profile-details-name">
            <span className="primary-text">
              {" "}
              Hello sir it's
              <span className="highlighted-text"> Swapnil Ramteke</span>
            </span>
          </div>

          <div className="profile-details-role">
            <span className="primary-text">
              {" "}
              <h1>
                {" "}
                <Typical
                  loop={Infinity}
                  steps={[
                    "Enthusiastic Developer",
                    1000,
                    "Full Stack Web Developer",
                    1000,
                    "MERN Stack Developer",
                    1000,
                    "React Developer",
                    1000,
                    "Node/Express Developer",
                    1000,
                  ]}
                />
              </h1>
              <span className="profile-role-tagline">
                Passion-driven learner and a web developer with the ability{" "}
                <br></br>
                to write clean,reusable, optimised code .<br></br>
                Looking forward to joining a progressive and challenging work
                environment.
              </span>
            </span>
          </div>
          <div className="profile-options">
            <button
              className="btn primary-btn"
              onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
            >
              {""}
              Hire Me
            </button>
            <a href="https://drive.google.com/file/d/1O42zJhnD-hBQDx7ho_UKiC9DsPWxqSiK/view" download="">
              <button className="btn highlighted-btn">Get Resume</button>
            </a>
          </div>
        </div>
        <div className="profile-picture">
          <div className="profile-picture-background"></div>
        </div>
      </div>
    </div>
  );
}
